/**
 * [Impure] Scroll body or element from key.
 * @param value - Position to scroll to.
 * @param key - Key to select element with.
 */
export function scroll(value: number | string, key?: string) {
    let target;
    if (typeof value === "string") value = parseInt(value);                                 // Get scroll value from string.
    if (key && key[0] === "#") target = document.getElementById(key.slice(1));              // Select target by #id.
    if (key && key[0] === ".") target = document.getElementsByClassName(key.slice(1))[0];   // Select target by .className.
    if (target) target.scrollTop = value;                                                   // Scroll target to value.
    window.scrollTo(0, value);                                                              // Scroll window to value.
}
